export * from './dokReestrDossier.component';
export * from './dokReestrDossier.service';
